<template>
  <div>
    <h6>Members settings</h6>
    <a href="#" class="accept-request btn-size" data-toggle="modal" data-target="#invite-members" data-cy="inviteMembers">
      <span class="add-person-icon-text">
        <svg class="add-person-icon">
          <use xlink:href="/svg-icons/sprites/icons.svg#add-person-icon" />
        </svg>
        <span>Invite user</span>
      </span>
    </a>
    <GroupMembersSettingsList />
    <ModalInviteNewMember />
  </div>
</template>

<script>
import ModalInviteNewMember from './ModalInviteNewMember.vue';
import GroupMembersSettingsList from './GroupMembersSettingsList.vue';
export default {
  name: "GroupMembersSettings",

  components: { ModalInviteNewMember, GroupMembersSettingsList }
}
</script>

<style scoped>
.accept-request {
  padding: 3px;
}

.add-person-icon {
  width: 25px;
  height: 25px;
  margin: 0 5px;
}

.add-person-icon-text {
  display: flex;
  align-items: center;
  color: white !important;
}

.add-person-icon-text span {
  font-size: 14px;
  margin-right: 4px;
  letter-spacing: 1px;
}

.notification-list {
  padding: 0 20px 20px;
}
.btn-size {
  width: 200px;
  display: flex;
  justify-content: center;
}
</style>